var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficInfoSelenaNar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_info_x5F_selena_x5F_nar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "54px",
    viewBox: "0 0 70 54",
    style: {
      enableBackground: "new 0 0 70 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_info_x5F_selena_x5F_nar_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Backround_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2B236"
    },
    d: "M22.586,44.586L3.414,25.414c-0.781-0.781-0.781-2.047,0-2.828L22.586,3.414 c0.781-0.781,2.047-0.781,2.828,0l19.172,19.172c0.781,0.781,0.781,2.047,0,2.828L25.414,44.586 C24.633,45.367,23.367,45.367,22.586,44.586z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,42.792c-0.384,0-0.768-0.146-1.061-0.438L5.646,25.061c-0.585-0.585-0.585-1.536,0-2.121L22.939,5.646 c0.585-0.585,1.536-0.585,2.121,0l17.293,17.293c0.585,0.585,0.585,1.536,0,2.121L25.061,42.354 C24.768,42.646,24.384,42.792,24,42.792z M7.414,24L24,40.586L40.586,24L24,7.414L7.414,24z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "destination_x5F_flag_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "tour_1_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M24,50v-2c21.417,0,36.266-1.883,38.751-4.914c0.318-0.389,0.311-0.68,0.269-0.89 c-0.45-2.249-4.747-3.155-8.199-3.883c-3.299-0.695-5.903-1.244-6.715-2.866c-0.451-0.903-0.396-1.896,0.159-2.792 C49.231,31.092,51.59,30,54,30v2c-1.865,0-3.516,0.868-4.034,1.707c-0.242,0.392-0.165,0.658-0.071,0.846 c0.379,0.759,3.245,1.362,5.338,1.804c4.237,0.894,9.04,1.905,9.748,5.447c0.181,0.903-0.056,1.784-0.683,2.55 C60.27,49.267,37.321,50,24,50z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 16,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 22,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 18,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 24,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 20,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 16,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 24,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 20,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 16,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 22,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 18,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 24,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 20,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 16,
    style: {
      fill: "#FFFFFF"
    },
    width: 2,
    height: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "car_x5F_front",
    d: "M31.333,24l-0.74-1.109C30.223,22.334,29.598,22,28.93,22H25.07c-0.669,0-1.293,0.334-1.664,0.891 L22.667,24H22v1v2v1v2h2v-2h6v2h2v-2v-1v-2v-1H31.333z M24.238,23.445C24.424,23.166,24.735,23,25.07,23h3.859 c0.335,0,0.646,0.166,0.832,0.445L30.798,25h-7.596L24.238,23.445z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "car_x5F_back",
    d: "M25.07,20H27v-2v-1h-0.667l-0.74-1.109C25.223,15.334,24.598,15,23.93,15H20.07 c-0.669,0-1.293,0.334-1.664,0.891L17.667,17H17v1v2v1v2h2v-2h3.428C23.149,20.364,24.083,20,25.07,20z M18.202,18l1.036-1.555 C19.424,16.166,19.735,16,20.07,16h3.859c0.335,0,0.646,0.166,0.832,0.445L25.798,18H18.202z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficInfoSelenaNar);
export default __webpack_public_path__ + "static/media/icon-traffic_info_selena_nar.64bd00c662c9f56a6389b4d528aa4385.svg";
export { ForwardRef as ReactComponent };